import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import Configurer from "../../components/Configurer";

import DataGrid from "../../components/DataGrid";

import AdminModule from "../../components/boxes/AdminModule";
import { adminPages } from "../../variables/adminPages";
import WidgetComponents from "../../components/widgets/WidgetComponents";
import { adminWidgets } from "../../variables/adminWidgets";
import { energyWidgets } from "../../variables/energyWidgets";
import { carbonPages } from "../../variables/carbonPages";
import { checkPermission, checkTextTranslation, checkTranslation } from "../../utils/useful";
import { carbonWidgets } from "../../variables/carbonWidgets";


class AdminWidgetsPage extends React.Component {


    state = {
        // info: {
        modules: []
        // }
    }


    componentDidMount() {
        // console.log('this.props.widget', this.props.widget)
        if (Array.isArray(this.props.modules) && this.props.modules.length > 0) {
            this.setState({ modules: this.props.modules })
            return
        }
        this.setState({ modules: Object.values(adminWidgets) })

        // this.setState({ modules: Object.values(adminWidgets) })
    }
    componentDidUpdate(prevProps) {
        if (this.props.modules !== prevProps.modules && Array.isArray(this.props.modules)) {
            if (this.props.modules.length > 0) {
                this.setState({ modules: this.props.modules })
                return
            }
            // fallthrough to widget-based handling below
        }
        if (this.props.widget != prevProps.widget) {
            console.log('this.props.widget', this.props.widget)
            if (this.props.widget == 'adminPages') {
                this.setState({ modules: Object.values(adminWidgets) })
            } else if (this.props.widget == 'energyPages') {
                this.setState({ modules: Object.values(energyWidgets) })
            } else if (this.props.widget == 'energyPages') {
                this.setState({ modules: Object.values(carbonWidgets) })
            }
        }
    }




    render() {
        const content = (
            <div className={"row m-0"} >
                <div className={"col-12 pt-0 " + (this.props.noBackground ? 'pb-0' : 'pb-4')}>
                    <div className="row m-0">
                        {this.state.modules?.map((prop) => {
                            let Component = WidgetComponents[prop.key]
                            if (Component && true) {
                                let variables = {
                                    permissionRoot: prop.permissionParent,
                                    ...(this.props.variables || {}),
                                }

                                const isTableWidget = prop.key === 'TableWidget'
                                /** Height/width caps and scroll only for TableWidget; other widgets use natural height. */
                                const tableWrapperSizing = isTableWidget
                                    ? {
                                        maxHeight: '400px',
                                        maxWidth: '100%',
                                        overflow: 'auto',
                                    }
                                    : {}

                                const wrapperStyle = this.props.noBackground
                                    ? {
                                        // Remove only the outer card background/shadow.
                                        backgroundColor: 'transparent',
                                        borderRadius: 10,
                                        boxShadow: 'none',
                                        padding: '1.5rem 0.25rem 0.75rem 0.25rem',
                                        ...tableWrapperSizing,
                                    }
                                    : {
                                        backgroundColor: '#fff',
                                        borderRadius: 10,
                                        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
                                        padding: '1.5rem 0.25rem 0.75rem 0.25rem',
                                        ...tableWrapperSizing,
                                    }

                                return (
                                    <div className={"w-100 mb-1 p-1 col-12  col-md-" + (prop.col ?? "6")} key={prop._id}>
                                        <div className={'d-flex flex-column ' + (isTableWidget ? 'custom-scrollbar-widget' : '')} style={wrapperStyle}>
                                            {!this.props.noBackground && (
                                                <p className="text-start text-bold mt-2 mb-3 text-normal">
                                                    {checkTranslation(prop.title)}
                                                </p>
                                            )}
                                            <Component widget={prop} dashboard={this.state.info} variables={variables} />
                                        </div>
                                    </div>
                                )
                            }
                        })}
                    </div>
                </div>
            </div>
        )

        if (this.props.noBackground) {
            return content
        }

        return (
            <Configurer
                settingsInfo={{ showFooter: true, showTabBar: true, showHeader: true, headerTitle: this.props.title, button: {} }}
                title={this.props.title}
                description={this.props.description}
                className=""
            >
                {content}
            </Configurer>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminWidgetsPage);
